let baseURL = process.env.VUE_APP_BASE_API || ""

export const GET_PIPE_LIST = baseURL + "/qcp/product/selectByConstructId"
export const GET_WELL_LIST = baseURL + "/qcp/manhole/ManholeExtGoodsList"